// src/actions/socketTypes.js

export const SOCKET_CONNECT = "SOCKET_CONNECT"
export const SOCKET_DISCONNECT = "SOCKET_DISCONNECT"